import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { calculateCharged } from "@/services/api/cresivoxServer";

const REDUCER_NAME = "form";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// Define a new type matching your JSON payload shape
interface iShippingCalculationPayload {
  origin_address: {
    country_alpha2: string;
    city: string;
    postal_code: string;
  };
  destination_address: {
    country_alpha2: string;
    city: string;
    postal_code: string;
  };
  weight: number;
  length: number;
  width: number;
  height: number;
  declared_value: number;
  declared_currency: string;
  incoterms: string;
  is_insured: boolean;
  hs_code: string;
  quantity: number;
  contains_battery_pi966: boolean;
  contains_battery_pi967: boolean;
  contains_liquids: boolean;
}

export const calculateShippingCharged = createAsyncThunk<
  iGenericResponse<any | null> | null,
  iShippingCalculationPayload,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("calculateShippingCharged"),
  // @ts-ignore
  async (payload, { rejectWithValue }) => {
    try {
      const response = await calculateCharged.calculateShippingCharged(payload);

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK:
            return { httpStatusCode, data, message };
          default:
            return rejectWithValue({ httpStatusCode, message });
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);
